<template>
    <!-- GS 테스트를 위한 임시 작업, 20250612 -->

    <!-- <div v-xe-pm.E.A> -->
    <div>
        <!-- <title-icon :title="$t('장비설정 관리')" icon="fa-plug" /> -->
        <header-box :title="`${$t('관제점 구성 관리')} > ${$t('데이터 수집 설정')}`" />

        <div class="row">
            <div class="col-md-3">
                <panel :title="$t('장비 목록')" :variant="panelVariant" bodyClass="p-0" :isHoverButton="false"
                    :fixedHeight="'80vh'" :class="{ 'panel-loading': reload }" showEditing="false" hideExpand="true"
                    hideReload="true" hideCollapse="true" hideRemove="true" @panel-reload="initSetting">
                    <template slot="button">
                        <button v-if="curNodeType == ''" class="btn btn-xs btn-primary m-r-5"
                            @click="openNewServerModal()">
                            <i class="fa fa-plus"></i> {{ $t("데이터 수집기 추가") }}
                        </button>
                        <button v-else-if="curNodeType == 'server'" class="btn btn-xs btn-primary m-r-5"
                            @click="openNewChannelModal()">
                            <i class="fa fa-plus"></i> {{ $t("통신채널 추가") }}
                        </button>
                        <button v-else-if="curNodeType == 'channel'" class="btn btn-xs btn-primary m-r-5"
                            @click="openNewFacilityModal()">
                            <i class="fa fa-plus"></i> {{ $t("계측장치 추가") }}
                        </button>
                        <button v-else-if="curNodeType == 'facility'" class="btn btn-xs btn-primary m-r-5"
                            @click="openNewSubFacilityModal()">
                            <i class="fa fa-plus"></i> {{ $t("서브모듈 추가") }}
                        </button>
                        <button class="btn btn-xs btn-purple m-r-5" @click="toggleExpand()">
                            <i class="fa" :class="isExpand ? 'fa-angle-double-right' : 'fa-angle-double-down'"></i>
                        </button>
                        <button class="btn btn-xs btn-green m-r-5" @click="initSetting()">
                            <i class="fa fa-redo"></i>
                        </button>
                    </template>
                    <liquor-tree ref="tree" v-if="Array.isArray(treeData) && treeData.length > 0 && isShow"
                        :data="treeData" :options="treeOptions" @node:dragging:finish="dragFinish"
                        @node:selected="onNodeSelected">
                        <template slot-scope="{ node }">
                            <div class="row width-full xe-hover-box"
                                @contextmenu.stop.prevent="onNodeRightClick($event, node)">
                                <div class="col-lg-11">
                                    <template v-if="node.data.type == 'server'">
                                        <app-icon :icon="node.data.icon" />
                                        {{ node.text }}

                                        <!-- TODO: serverStatus 정상화하고 동작중 표현방법 다시 생각해 봐야 함.
                    <i class="fas fa-plug m-l-5" v-if="node.data.serverStatus && node.data.serverStatus.keepAlive && node.data.serverStatus.keepAlive.passedMin() < 20" v-b-tooltip :title="$t('동작중')"></i> -->
                                    </template>
                                    <span v-else-if="node.data.type == 'channel'"
                                        :class="[node.data.enable ? '' : 'text-black-transparent-5']">
                                        <app-icon
                                            :icon="node.data.icon"
                                            :class="
                                                node.data.keepAlive && node.data.keepAlive.passedMin() < 20
                                                    ? 'fa-spin'
                                                    : ''
                                            "
                                        />
                                        {{ node.text }}
                                        <b-badge variant="secondary" class="xe-hover-button m-l-5">
                                            {{ node.data.channelType }}
                                        </b-badge>
                                    </span>
                                    <span v-else-if="node.data.type == 'facility' || node.data.type == 'subFacility'"
                                        :class="[node.data.isUse ? '' : 'text-black-transparent-5']">
                                        <app-icon :icon="node.data.icon" />
                                        {{ node.text }}
                                        <b-badge v-if="node.data.type == 'facility'" variant="secondary"
                                            class="xe-hover-button m-l-5">
                                            {{ node.data.driverType }}
                                        </b-badge>
                                        <b-badge v-if="node.data.type == 'subFacility'" variant="secondary"
                                            class="xe-hover-button m-l-5">
                                            CT {{ node.data.ct }}
                                        </b-badge>
                                    </span>
                                    <template v-else-if="node.data.type == ''">
                                        <app-icon :icon="node.data.icon" />
                                        {{ node.text }}
                                    </template>
                                </div>
                            </div>
                        </template>
                    </liquor-tree>

                    <div class="panel-loader" v-if="reload"><span class="spinner-small"></span></div>
                </panel>
            </div>
            <div class="col-md-9">
                <data-collection-detail-panel :option="mapOption" :parentData="selectedNode"
                    @refresh-tree-data="initSetting()" @server-save-done="onServerSaveDone"
                    @channel-save-done="onChannelSaveDone" @facility-save-done="onFacilitySaveDone"
                    @subFacility-save-done="onSubFacilitySaveDone" />
            </div>
        </div>

        <b-modal id="server-modal" ref="serverModal" :hide-footer="true"
            :title="popupServer.serverIdx ? $t(`데이터 수집기 설정`) : $t('데이터 수집기 추가')">
            <server-popup :server="popupServer" :childrens="popupServer.childrens" @save-done="onServerSaveDone" />
        </b-modal>

        <b-modal ref="channelModal" :hide-footer="true"
            :title="popupChannel.channelIdx ? $t(`통신채널 설정`) : $t('통신채널 추가')">
            <channel-popup :serverIdx="popupChannel.serverIdx" :channelIdx="popupChannel.channelIdx"
                :childrens="popupChannel.childrens" @save-done="onChannelSaveDone" mode="popup" />
        </b-modal>

        <b-modal id="facilityModal" ref="facilityModal" :hide-footer="true"
            :title="popupFacility.facilityIdx ? $t(`계측장치 설정`) : $t('계측장치 추가')">
            <facility-popup :serverIdx="popupFacility.serverIdx" :channelIdx="popupFacility.channelIdx"
                :facilityIdx="popupFacility.facilityIdx" :channelType="popupFacility.channelType"
                :childrens="popupFacility.childrens" :subFacilityList="getSubFacilityList"
                @save-done="onFacilitySaveDone" type="facility" />
        </b-modal>

        <b-modal ref="subFacilityModal" :hide-footer="true"
            :title="popupSubFacility.facilityIdx ? $t(`서브모듈 설정`) : $t('서브모듈 추가')" size="md">
            <facility-popup :serverIdx="popupSubFacility.serverIdx" :channelIdx="popupSubFacility.channelIdx"
                :parentFacilityIdx="popupSubFacility.parentFacilityIdx" :facilityIdx="popupSubFacility.facilityIdx"
                :channelType="popupSubFacility.channelType" :newCT="popupSubFacility.ct"
                @save-done="onSubFacilitySaveDone" type="subFacility" />
        </b-modal>

        <!-- 컨텍스트 메뉴 -->
        <Transition name="context-menu-fade">
            <div v-show="showContextMenu" class="context-menu"
                :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }" @click.stop>
                <div class="context-menu-header">
                    <i :class="`fas ${contextMenuIcon}`"></i>
                    <span>{{ getContextMenuTitle() }}</span>
                </div>
                <div class="context-menu-items">
                    <!-- 루트 노드 -->
                    <div v-if="contextMenuNode?.data.type === ''" class="context-menu-item"
                        @click.stop="handleContextMenuAction('addServer', $event)">
                        <i class="fa fa-plus"></i>
                        <span>{{ $t("데이터 수집기 추가") }}</span>
                    </div>

                    <!-- 서버 노드 -->
                    <div v-if="contextMenuNode?.data.type === 'server'" class="context-menu-item"
                        @click.stop="handleContextMenuAction('addChannel', $event)">
                        <i class="fa fa-plus"></i>
                        <span>{{ $t("통신채널 추가") }}</span>
                    </div>

                    <!-- 채널 노드 -->
                    <div v-if="contextMenuNode?.data.type === 'channel'" class="context-menu-item"
                        @click.stop="handleContextMenuAction('addFacility', $event)">
                        <i class="fa fa-plus"></i>
                        <span>{{ $t("계측장치 추가") }}</span>
                    </div>

                    <!-- 계측장치 노드 -->
                    <div v-if="contextMenuNode?.data.type === 'facility'" class="context-menu-item"
                        @click.stop="handleContextMenuAction('addSubFacility', $event)">
                        <i class="fa fa-plus"></i>
                        <span>{{ $t("서브모듈 추가") }}</span>
                    </div>

                    <!-- 공통 -->
                    <div class="context-menu-item" @click.stop="toggleExpand()">
                        <i class="fa" :class="'fa-angle-double-down'"></i>
                        <span>{{ isExpand ? $t("트리 확장") : $t("트리 축소") }}</span>
                    </div>
                    <div class="context-menu-item" @click.stop="initSetting()">
                        <i class="fa fa-redo"></i>
                        <span>{{ $t("새로고침") }}</span>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<style scoped>
/* 신규추가 start*/
.panel {
    background-color: white !important;
    overflow: auto;
}

/* 신규추가 end*/

.tree-node.matched>.tree-content {
    background: #f7f2e7;
}

.tree-children {
    transition: unset;
}

::v-deep #server-modal .modal-dialog {
    width: 35% !important;
    max-width: 35% !important;
}

::v-deep #facilityModal .modal-dialog {
    width: 35% !important;
    max-width: 35% !important;
}

/* 컨텍스트 메뉴 스타일 */
.context-menu {
    position: fixed;
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    min-width: 180px;
    font-size: 13px;
}

/* 컨텍스트 메뉴 애니메이션 */
.context-menu-fade-enter-active,
.context-menu-fade-leave-active {
    transition: opacity 0.2s;
}

.context-menu-fade-enter,
.context-menu-fade-leave-to {
    opacity: 0;
}

.context-menu-header {
    padding: 8px 12px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 6px;
}

.context-menu-header i {
    color: #6c757d;
    font-size: 12px;
}

.context-menu-items {
    padding: 4px 0;
}

.context-menu-item {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: background-color 0.2s ease;
}

.context-menu-item:hover {
    background-color: #f8f9fa;
}

.context-menu-item i {
    width: 14px;
    text-align: center;
    color: #6c757d;
}

.context-menu-item span {
    color: #495057;
}
</style>

<script>
import LiquorTree from "liquor-tree";
import backEndApi from "@api/backEndApi.js";
import ServerPopup from "./components/ServerPopup.vue";
import ChannelPopup from "./components/ChannelPopup.vue";
import FacilityPopup from "./components/FacilityPopup.vue";
import DataCollectionDetailPanel from "./components/DataCollectionDetailPanel.vue";
import HeaderBox from "@views/component/headerBox/analysis/Header.vue";

// import HeaderBox from "../light/component/headerBox/analysis/Header.vue"

// TODO: 루트 선택시 서버 추가 버튼이 활성화 되지 않음..

// TODO: 관제점 맵핑  사용중 필터 클릭하면, 그리드 내용이 이상해짐.
// TODO: 관제점 맵핑  하위장비 클릭시 - 속성찾기 문자열로 필터링하는 기능 변경해야 함.
// TODO: Use Only 체크박스 모양 바꿔야 함...

// TODO: 에이전트 할당, 에이전트 재시작

export default {
    components: {
        [LiquorTree.name]: LiquorTree,
        ServerPopup,
        ChannelPopup,
        FacilityPopup,
        DataCollectionDetailPanel,
        HeaderBox,
    },
    data() {
        return {
            treeOptions: {
                dnd: false,
            },
            selectedNode: null,
            isShow: true,

            servers: [],
            channels: [],
            facilities: [],
            treeNodes: [],

            curNodeType: "",
            curNodeData: {},
            curChildrens: 0, // 자식 노드 갯수
            curNodeParent: {},

            mapOption: {}, // 관제점맵핑에서 사용

            popupServer: {},
            popupChannel: {},
            popupFacility: {},
            popupSubFacility: {},

            originTreeData: [],

            isExpand: true,
            reload: false,

            // 컨텍스트 메뉴 관련
            showContextMenu: false,
            contextMenuX: 0,
            contextMenuY: 0,
            contextMenuNode: null,
            contextMenuIcon: "",
        };
    },
    computed: {
        treeData() {
            return JSON.parse(JSON.stringify(this.treeNodes));
        },
        getSubFacilityList() {
            if (this.selectedNode?.data.type !== "facility") return [];

            let subFacilityList = [];

            this.selectedNode?.children
                ?.filter((child) => child.data.type === "subFacility")
                .map((child) => {
                    subFacilityList.push(child);
                });
            return subFacilityList;
        },
    },
    watch: {
        treeData: function () {
            this.isShow = false;
            this.$nextTick(() => {
                this.isShow = true;
            });
        },
    },
    mounted() {
        this.initSetting();
        // 전역 우측클릭 방지
        document.addEventListener("contextmenu", this.preventContextMenu);
    },
    beforeDestroy() {
        // 이벤트 리스너 정리
        document.removeEventListener("contextmenu", this.preventContextMenu);
    },
    methods: {
        preventContextMenu(event) {
            event.preventDefault();
        },
        onNodeRightClick(event, node) {
            event.preventDefault();
            event.stopPropagation();

            // 현재 열린 컨텍스트 메뉴가 있다면 먼저 닫기
            if (this.showContextMenu) {
                this.closeContextMenu();
                // 애니메이션이 완료된 후 새로운 메뉴 열기
                setTimeout(() => {
                    this.openContextMenu(event, node, node.data.icon);
                }, 200);
            } else {
                this.openContextMenu(event, node, node.data.icon);
            }
        },

        openContextMenu(event, node, icon) {
            // 컨텍스트 메뉴 위치 설정
            this.contextMenuX = event.clientX;
            this.contextMenuY = event.clientY;
            this.contextMenuNode = node;
            this.showContextMenu = true;

            this.contextMenuIcon = icon;

            // 다른 곳 클릭 시 메뉴 닫기
            this.$nextTick(() => {
                document.addEventListener("click", this.closeContextMenu, { once: true });
            });
        },

        closeContextMenu() {
            this.showContextMenu = false;
            this.contextMenuNode = null;
        },

        getContextMenuTitle() {
            if (!this.contextMenuNode) return "";

            const type = this.contextMenuNode.data.type;
            switch (type) {
                case "":
                    return this.$t("수집 네트워크");
                case "server":
                    return this.$t("데이터 수집기");
                case "channel":
                    return this.$t("통신채널");
                case "facility":
                    return this.$t("계측장치");
                case "subFacility":
                    return this.$t("서브모듈");
                default:
                    return "";
            }
        },

        handleContextMenuAction(action, event) {
            event.preventDefault();
            event.stopPropagation();

            // contextMenuNode가 null인 경우 처리
            if (!this.contextMenuNode) {
                console.warn("handleContextMenuAction: contextMenuNode is null");
                return;
            }

            // contextMenuNode를 임시 변수에 저장
            // const selectedNode = this.contextMenuNode;

            // 노드 선택 상태로 설정
            // this.onNodeSelected(selectedNode);

            switch (action) {
                case "addServer":
                    this.openNewServerModal();
                    break;
                case "addChannel":
                    this.openNewChannelModal();
                    break;
                case "addFacility":
                    this.openNewFacilityModal();
                    break;
                case "addSubFacility":
                    this.openNewSubFacilityModal();
                    break;
            }

            // 마지막에 컨텍스트 메뉴 닫기
            this.closeContextMenu();
        },
        // routeRoot 값이 true일 경우 최상위 노드 자동 선택
        async initSetting() {
            if (this.$refs.tree) {
                this.originTreeData = JSON.parse(JSON.stringify(this.$refs.tree.tree.model[0].children));
            }

            this.reload = true;

            this.isExpand = true;

            let nodes = await backEndApi.facility.searchFacilityTree().then(({ data }) => {
                if (this.$err(data)) return;

                return data;
            });
            this.reload = false;
            this.originExpanded(nodes, this.originTreeData);

            this.treeNodes.range([
                {
                    text: this.$t(`수집 네트워크`),
                    state: { expanded: true },
                    data: { type: "", icon: "fa fa-server" },
                    children: nodes,
                },
            ]);

            setTimeout(
                function () {
                    this.reSelectNodeData();
                    // 최초 로딩시 최상위 노드 자동 선택
                    if (!this.selectedNode && this.treeNodes.length > 0) {
                        this.selectRootNode();
                    }
                }.bind(this),
                200
            );

            if (this.showContextMenu) {
                this.closeContextMenu();
            }
        },
        reSelectNodeData() {
            if (!this.selectedNode) return;

            const newModel = this.$refs.tree.model;

            const reloadData = this.findNode(this.selectedNode, newModel);
            this.selectedNode = reloadData;
        },
        findNode(selectNode, childNodes) {
            let findData = null;

            for (let i = 0; i < childNodes.length; i++) {
                if (childNodes[i].data.type === "facility" || childNodes[i].data.type === "subFacility") {
                    if (
                        childNodes[i].data.type === selectNode.data.type &&
                        childNodes[i].data.text === selectNode.data.text &&
                        childNodes[i].data.facilityIdx === selectNode.data.facilityIdx
                    ) {
                        findData = childNodes[i];
                        break;
                    }
                }
            }

            if (findData === null) {
                for (let i = 0; i < childNodes.length; i++) {
                    if (!childNodes[i].children) continue;
                    if (childNodes[i].children.length == 0) continue;

                    const result = this.findNode(selectNode, childNodes[i].children);
                    return result;
                }
            } else {
                return findData;
            }
        },
        originExpanded(newTreeData, originData) {
            for (let i = 0; i < originData.length; i++) {
                let child = originData[i].children;

                if (newTreeData[i] && originData[i].state && originData[i].state.expanded === true) {
                    newTreeData[i].state = originData[i].state;
                }

                if (child && child.length > 0) {
                    this.originExpanded(newTreeData[i].children, child);
                }
            }
        },
        toggleExpand() {
            this.isExpand = !this.isExpand;
            this.isExpand ? this.$refs.tree.tree.collapseAll() : this.$refs.tree.tree.expandAll();

            if (this.showContextMenu) {
                this.closeContextMenu();
            }
        },
        dragFinish(node, destinationNode) {
            console.log("dragFinish. node, destinationNode", node, destinationNode);
        },
        onNodeSelected(node) {
            // node가 null이거나 undefined인 경우 처리
            if (!node) {
                console.warn("onNodeSelected: node is null or undefined");
                return;
            }

            if (node.children) {
                // states 객체가 없으면 생성
                if (!node.states) {
                    node.states = {};
                }
                // expanded 속성이 없으면 false로 초기화
                if (typeof node.states.expanded === "undefined") {
                    node.states.expanded = false;
                }
                node.states.expanded = !node.states.expanded;
            }

            this.selectedNode = node;

            this.curNodeType = "";
            this.mapOption = {};

            if (node.data.type == "") return;

            this.curNodeType = node.data.type;
            this.curNodeData = node.data;
            this.curChildrens = node.children ? node.children.length : 0;
            this.curNodeParent = node.parent ? node.parent.data : {};

            if (node.data.type == "facility") {
                this.mapOption = {
                    server: node.parent?.parent?.data || {},
                    channel: node.parent?.data || {},
                    parent: null,
                    facility: node.data,
                };
            } else if (node.data.type == "subFacility") {
                this.mapOption = {
                    server: node.parent?.parent?.parent?.data || {},
                    channel: node.parent?.parent?.data || {},
                    parent: node.parent?.data || {},
                    facility: node.data,
                };
            }
        },
        //#region 모달

        // openNodeModal(node) {
        //     let { data } = node;

        //     switch (data.type) {
        //         case "server":
        //             this.openServerModal(data);
        //             break;
        //         case "channel":
        //             this.openChannelModal(data);
        //             break;
        //         case "facility":
        //             this.openFacilityModal(data);
        //             break;
        //         case "subFacility":
        //             this.openSubFacilityModal(data);
        //             break;
        //     }
        // },
        openNewServerModal() {
            this.popupServer = {};
            this.$refs.serverModal.show();
        },
        openServerModal(server) {
            this.popupServer = server;
            this.popupServer.childrens = this.curChildrens;
            this.$refs.serverModal.show();
        },
        onServerSaveDone() {
            this.$refs.serverModal.hide();
            this.popupServer = {};
            this.initSetting();
        },

        openNewChannelModal() {
            this.popupChannel = { serverIdx: this.curNodeData.serverIdx };
            this.$refs.channelModal.show();
        },
        openChannelModal(channel) {
            this.popupChannel = channel;
            this.popupChannel.childrens = this.curChildrens;
            this.$refs.channelModal.show();
        },
        onChannelSaveDone() {
            this.$refs.channelModal.hide();
            this.popupChannel = {};

            this.initSetting();
        },

        openNewFacilityModal() {
            this.popupFacility = {
                serverIdx: this.curNodeData.serverIdx,
                channelIdx: this.curNodeData.channelIdx,
                channelType: this.curNodeData.channelType,
            };
            this.$refs.facilityModal.show();
        },

        openFacilityModal(facility) {
            this.popupFacility = facility;
            this.popupFacility.channelType = this.curNodeParent.channelType;
            this.popupFacility.childrens = this.curChildrens;
            this.$refs.facilityModal.show();
        },

        onFacilitySaveDone() {
            this.$refs.facilityModal.hide();
            this.popupFacility = {};
            this.initSetting();
        },

        openNewSubFacilityModal() {
            /**
             * NOTE - 선택된 노트에 존재하는 마지막 ct 값을 찾아 +1
             */
            let selectedNode = this.selectedNode;
            // let newCT = -1;
            // if (selectedNode.children.length > 0) {
            //   newCT = 1;
            // } else {
            //    //NOTE - ct 값의 크기에 따라 정렬
            //   selectedNode.children.sort((a, b) => {
            //     if (Number(a.data.ct) > Number(b.data.ct)) {
            //       return 1;
            //     }

            //     if (Number(a.data.ct) < Number(b.data.ct)) {
            //       return -1;
            //     }

            //     return 0;
            //   });

            //   newCT = Number(selectedNode.children[selectedNode.children.length - 1].data.ct) + 1;
            // }

            // Arrange by badblock
            let newCT = 1; // Default Value
            if (selectedNode.children.length > 0) {
                selectedNode.children.sort((a, b) => Number(a.data.ct) - Number(b.data.ct));
                newCT = Number(selectedNode.children[selectedNode.children.length - 1].data.ct) + 1;
            }

            this.popupSubFacility = {
                serverIdx: this.curNodeData.serverIdx,
                channelIdx: this.curNodeData.channelIdx,
                parentFacilityIdx: this.curNodeData.facilityIdx,
                channelType: this.curNodeParent.channelType,
                deviceId: this.curNodeParent.deviceId,
            };

            this.popupSubFacility["ct"] = newCT;
            this.$refs.subFacilityModal.show();
        },

        openSubFacilityModal(facility) {
            this.popupSubFacility = facility;
            this.popupSubFacility.channelType = this.curNodeParent.channelType;
            this.$refs.subFacilityModal.show();
        },

        async onSubFacilitySaveDone() {
            this.$refs.subFacilityModal.hide();
            this.popupSubFacility = {};
            this.initSetting();
        },

        //#endregion

        // 최상위 노드 자동 선택
        selectRootNode() {
            if (this.treeNodes.length > 0) {
                const rootNode = this.treeNodes[0];
                this.onNodeSelected(rootNode);
            }
        },
    },
};
</script>
